import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'

// Über Uns
import Unser_Haus from '@/views/Ueber_Uns/Unser_Haus'
import Die_Geschichte from '@/views/Ueber_Uns/Die_Geschichte'
import Unser_Team from '@/views/Ueber_Uns/Unser_Team'
import Unser_Pflegekonzept from '@/views/Ueber_Uns/Unser_Pflegekonzept'

// Angebote
import Kurzzeitpflege from '@/views/Angebote/Kurzzeitpflege'
import Langzeitpflege from '@/views/Angebote/Langzeitpflege'
import Gemeinsames_Mittagessen from '@/views/Angebote/Gemeinsames_Mittagessen'
import Zivildienstplaetze from '@/views/Angebote/Zivildienstplaetze'
import Praktikumsplaetze from '@/views/Angebote/Praktikumsplaetze'
import Heimentgelte from '@/views/Angebote/Heimentgelte'

import Anfahrt from '@/views/Anfahrt'

import Impressum from '@/components/core/Impressum'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },

    // Über Uns Dropdown
    {
      path: '/ueber_uns/unser_haus',
      name: 'unser_haus',
      component: Unser_Haus
    },
    {
      path: '/ueber_uns/die_geschichte',
      name: 'die_geschichte',
      component: Die_Geschichte
    },
    {
      path: '/ueber_uns/Unser_Team',
      name: 'Unser_Team',
      component: Unser_Team
    },
    {
      path: '/ueber_uns/unser_pflegekonzept',
      name: 'unser_pflegekonzept',
      component: Unser_Pflegekonzept
    },
    
    // Angebote Dropdown
    {
      path: '/angebote/kurzzeitpflege',
      name: 'kurzzeitpflege',
      component: Kurzzeitpflege,
    },
    {
      path: '/angebote/langzeitpflege',
      name: 'langzeitpflege',
      component: Langzeitpflege,
    },
    {
      path: '/angebote/gemeinsames_mittagessen',
      name: 'gemeinsames_mittagessen',
      component: Gemeinsames_Mittagessen,
    },
    {
      path: '/angebote/zivildienstplaetze',
      name: 'zivildienstplaetze',
      component: Zivildienstplaetze,
    },
    {
      path: '/angebote/praktikumsplaetze',
      name: 'praktikumsplaetze',
      component: Praktikumsplaetze,
    },
    {
      path: '/angebote/heimentgelte',
      name: 'heimentgelte',
      component: Heimentgelte,
    },

    // Kontakt & Anfahrt
    {
      path: '/kontakt_anfahrt',
      name: 'anfahrt',
      component: Anfahrt,
    },
    

    // Footer
    {
      path:'/impressum',
      name: 'impressum',
      component: Impressum
    }
  ],

  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})
